import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { COMMON_FAIL_MESSAGE, converDateIntoLocal } from "Constants";
// IMPORT LANGUAGE
import LocaleStrings from "Languages";
// IMPORT ACTION
import { fetchDownloadSessionScanning } from "SessionanalyticActions";
import _ from "lodash";

function ExportSessionScanningExcelBtn(props) {
  const [loading, setLoading] = useState(false);

  const downloadCSV = () => {
    let { session, selectedOption } = props;

    let sessionID = !_.isEmpty(selectedOption) ? selectedOption.value : "";

    setLoading(true);
    /* Get List for CSV File */
    props.fetchDownloadSessionScanning(session, sessionID, (response) => {
      if (response.error === 0) {
        if (_.size(response.data.resource.sessionresponsegroup) > 0) {
          // Convert datetime into local time

          _.map(response.data.resource.sessionresponsegroup, (value, index) => {
            _.map(value, (innerVal, innnerIndex) => {
              // Deep delete
              delete innerVal["sessionid"];
              // Convert to localdate
              if (!_.isEmpty(innerVal["Check-in at"])) {
                innerVal["Check-in at"] = converDateIntoLocal(
                  innerVal["Check-in at"]
                );
              }
            });
          });

          props.JSONToCSVConvertor(
            response.data.resource.sessionresponsegroup,
            true
          );
        } else {
          props.showError(LocaleStrings.no_data_found);
        }

        setLoading(false);
      } else {
        props.showError(COMMON_FAIL_MESSAGE);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div>
      <span className="pull-right">
        <Button
          className="btn btn-custom-blue"
          onClick={downloadCSV}
          loading={loading}
        >
          <i className="fa fa-download i-custom-ms" aria-hidden="true" />
          Excel
        </Button>
      </span>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    session: state.session,
    // showError,
    // showSuccess,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { fetchDownloadSessionScanning, showError, showSuccess },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExportSessionScanningExcelBtn);

// function mapStateToProps(state) {
//   return {
//     session: state.session,
//     showModal: state.courseModal,
//   };
// }

// export default connect(mapStateToProps, {
//   showError,
//   showSuccess,
//   openCourseModal,
//   clearUnpublished,
// })(ExportSessionScanningExcelBtn);
